const getters = {
  userinfo: state => state.user.userinfo,
  isLogin: state => state.user.isLogin,
  crrInterval: state => state.user.crrInterval,

  siteInfo: state => state.app.siteInfo,
  siteName: state => state.app.siteName,

  previewImgDialog: state => state.upload.previewImgDialog,
  previewImgUrl: state => state.upload.previewImgUrl,

  pagesRoute: state => state.breadcrumb.pagesRoute,

  Bucket_pub: state => state.app.Bucket_pub,
  Bucket_internal: state => state.app.Bucket_internal,
  oss_internal_domain: state => state.app.oss_internal_domain,
  oss_pub_domain: state => state.app.oss_pub_domain,
  static_resource: state => state.app.static_resource,
  transportProtocol: state => state.app.transportProtocol,
  assetPurposeKey: state => state.selectKey.assetPurposeKey,
  isPro: state => state.app.isPro,
  cancelTokens: state => state.app.cancelTokens,
  nodeMap: state => state.app.nodeMap,

  quantityUnitKey: state => state.selectKey.quantityUnitKey,
  transferModes: state => state.selectKey.transferModes,
  tradeKindKey: state => state.selectKey.tradeKindKey,
  whethers: state => state.selectKey.whethers,
  whether: state => state.selectKey.whether,
  transfereeType: state => state.selectKey.transfereeType,
  tradeModeKey: state => state.selectKey.tradeModeKey,
  tradeModes: state => state.selectKey.tradeModes,
  planningKey: state => state.selectKey.planningKey,
  landStateKey: state => state.selectKey.landStateKey,
  equitiesKey: state => state.selectKey.equitiesKey,
  slopeKey: state => state.selectKey.slopeKey,
  sourceKey: state => state.selectKey.sourceKey,
  speciesKey: state => state.selectKey.speciesKey,
  treeSpeciesKey: state => state.selectKey.treeSpeciesKey,

  cmsProblemNode: state => state.cache.cmsProblemNode,

  cmsNoticeNode: state => state.cache.cmsNoticeNode,
  cmsNewsNode: state => state.cache.cmsNewsNode,
  focusesData: state => state.cache.focusesData,
  indexAdverts: state => state.cache.indexAdverts,

  friendlyLink: state => state.cache.friendlyLink,
  registerProtocol: state => state.cache.registerProtocol,
  bidding: state => state.cache.bidding,
  isEchartsComplete: state => state.app.isEchartsComplete,
  isMapJsComplete: state => state.app.isMapJsComplete,
  isOssComplete: state => state.app.isOssComplete,

  newsArticle: state => state.cache.newsArticle,
  noticeArticle: state => state.cache.noticeArticle,
  targetType: state => state.cache.targetType,
  areaInfo: state => state.cache.areaInfo,
  projectBigHall: state => state.cache.projectBigHall,
  nodeSubsets: state => state.cache.nodeSubsets,
  childNodesData: state => state.cache.childNodesData,
  activeCmsNode: state => state.cache.activeCmsNode,

  paymentModeKey: state => state.selectKey.paymentModeKey,
  priceUnitKey: state => state.selectKey.priceUnitKey,
  delayKey: state => state.selectKey.delayKey,
  auctionModeKey: state => state.selectKey.auctionModeKey,
  deadlineUnitKey: state => state.selectKey.deadlineUnitKey,
  capitalPropertyKey: state => state.selectKey.capitalPropertyKey,
  capitalSourceKey: state => state.selectKey.capitalSourceKey,
  actualityKey: state => state.selectKey.actualityKey,
  biddingTypeKey: state => state.selectKey.biddingTypeKey,
  tradeKindList: state => state.selectKey.tradeKindList,
  directionKey: state => state.selectKey.directionKey,
  bidCountKey: state => state.selectKey.bidCountKey,
  stateList: state => state.selectKey.stateList,
  stateKey: state => state.selectKey.stateKey,
  stateListAll: state => state.selectKey.stateListAll,
  target_type_operating: state => state.selectKey.target_type_operating,
  target_type_forest: state => state.selectKey.target_type_forest,
  landKindMap: state => state.selectKey.landKindMap,
  stateAllKey: state => state.selectKey.stateAllKey,
  selectLocId: state => state.bigdata.selectLocId,
  selectLocName: state => state.bigdata.selectLocName,
  statisData: state => state.bigdata.statisData,
}
export default getters
